<div class="invitation-card">
  <div class="content">
    <div class="icon-box">
      <mat-icon class="material-icons-rounded primary-icon">stacked_email</mat-icon>
    </div>
    <div class="text-box">
      <div class="body-label-fine text-color-variant">{{ invitation.invitationTimestamp|secondsToMilliseconds|date: 'dd.MM.yyyy' }}</div>
      <div class="text-color-text-on-accent">
        <span
          innerHTML="{{'MULTI_DOMAIN.START.INVITATIONS.DESCRIPTION' | translate:
          {inviter: invitation.inviter.firstName + ' ' + invitation.inviter.lastName, companyName: invitation.companyName} }}">
        </span>
      </div>
    </div>
  </div>
  <div class="actions">
    <button color="primary" mat-button
            (click)="onRejectInvitation.emit(invitation.domainId)">
      {{ 'MULTI_DOMAIN.START.INVITATIONS.REJECT' |translate }}
    </button>
    <button color="primary" mat-flat-button
            (click)="onAcceptInvitation.emit(invitation.domainId)">
      {{ 'MULTI_DOMAIN.START.INVITATIONS.ACCEPT' |translate }}
    </button>
  </div>
</div>


